<template>
  <div class="departments">
    <a-space :size="8">
      <span
        v-for="item in departmentList"
        :key="item.id"
        :class="['btn', { actived: activeKey === item.id }]"
        @click="handleClick(item)"
      >
        {{ item.department }}
      </span>
    </a-space>
  </div>
</template>
<script setup>
import { ref, defineEmits, onMounted } from 'vue'
import { requstMethod } from '../useStream'
const departmentList = ref([])
const activeKey = ref(undefined)
const emit = defineEmits(['changeDepartment'])
const handleClick = item => {
  activeKey.value = item.id
  emit('changeDepartment', false, item)
}
const getList = () => {
  const params = {
    url: 'doctor_assistant.html',
    method: 'post',
    query: { m: 'department_query', p: {} }
  }
  requstMethod(params).then(res => {
    const data = res.data || []
    departmentList.value = data
    const item = data?.[0] ?? {}
    activeKey.value = item.id
    emit('changeDepartment', true, item)
  })
}
onMounted(() => {
  getList()
})
</script>
<style scoped lang="scss">
.departments {
  .btn {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    padding: 5px 12px;
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    background-color: #fff;
    cursor: pointer;
    &.actived {
      border: 1px solid #1890ff;
      background: #1890ff1a;
      color: #1890ff;
    }
  }
}
</style>
